import {
  FILE_TYPE_LABELS,
  STATUS_COLOR,
  STATUS_LABEL,
  formatSize,
} from "./Meetings.utils";
import { Icons } from "../../constants/icon-library";

const FileRow = ({ item, onRemove }) => {
  const busy = item.status === "uploading" || item.status === "removing";
  const color = STATUS_COLOR[item.status] ?? "secondary";
  const loading = item.status === "uploading";

  return (
    <div className="d-flex align-items-center gap-3 p-3 mb-2 rounded-3 border border-translucent bg-body">
      <div
        className={`avatar avatar-m flex-shrink-0 rounded-2 bg-${color}`}
      ></div>
      <div className="flex-grow-1 overflow-hidden">
        <div className="d-flex align-items-center gap-2 mb-1">
          <p className="mb-0 fw-semibold text-body text-truncate lh-sm">
            {item.file.name}
          </p>
          <span className="badge badge-phoenix badge-phoenix-secondary flex-shrink-0">
            {FILE_TYPE_LABELS[item.type]}
          </span>
        </div>
        <div className="d-flex align-items-center flex-wrap gap-2">
          <span className="text-body-tertiary fs-10">
            {formatSize(item.file.size)}
          </span>

          <span
            className={`badge badge-phoenix badge-phoenix-${color} d-inline-flex align-items-center gap-1`}
          >
            {loading && (
              <span
                className="spinner-grow spinner-grow-sm"
                role="status"
                aria-hidden="true"
              />
            )}
            {STATUS_LABEL[item.status]}
            {loading && ` · ${item.progress}%`}
          </span>

          {item.error && (
            <span className="text-danger fs-10 d-flex align-items-center gap-1">
              <span className="fa-solid fa-triangle-exclamation" />
              {item.error}
            </span>
          )}
        </div>

        {loading && (
          <div className="progress mt-2 rounded-pill" style={{ height: 3 }}>
            <div
              className={`progress-bar bg-${color} progress-bar-striped progress-bar-animated rounded-pill`}
              role="progressbar"
              style={{ width: `${item.progress}%` }}
              aria-valuenow={item.progress}
              aria-valuemin={0}
              aria-valuemax={100}
            />
          </div>
        )}
      </div>

      {/* Remove button */}
      <button
        type="button"
        className="btn btn-phoenix-danger btn-sm flex-shrink-0 rounded-2 d-flex align-items-center justify-content-center"
        disabled={busy}
        onClick={() => onRemove(item)}
        title="Remove file"
        aria-label={`Remove ${item.file.name}`}
      >
        <i className={`wb ${Icons("remove")}`} />
      </button>
    </div>
  );
};

export default FileRow;
